///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class KidFriendlyScreen extends BaseScreen {

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.add(new Phaser.GameObjects.Image(this.scene, -1, -1, 'ui-atlas', 'kidFriendly_bg'+'0000').setOrigin(0, 0));

            let normalBtn = new Phaser.GameObjects.Image(this.scene, 240, 93, 'ui-atlas', 'hs_top_bg'+'0000');
            normalBtn.setScale(0.95, 1);
            normalBtn.alpha = 0.01;
            this.add(normalBtn);
            let kidFriendly = new Phaser.GameObjects.Image(this.scene, 240, 245, 'ui-atlas', 'hs_top_bg'+'0000');
            kidFriendly.setScale(0.95, 1);
            kidFriendly.alpha = 0.01;
            this.add(kidFriendly);

            let normal_label:Phaser.GameObjects.Text = this.scene.add.text(100, 90, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 22,
                "color": "#FFFFFF",
                "align": 'left'
            });
            normal_label.setOrigin(0, 0.5);
            this.add(normal_label);
            nscs.gameplay.Gameplay.setText(normal_label, 'StartGameBtn');

            let kid_label:Phaser.GameObjects.Text = this.scene.add.text(130, 237, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 22,
                "color": "#FFFFFF",
                "align": 'left'
            });
            kid_label.setOrigin(0, 0.5);
            this.add(kid_label);
            nscs.gameplay.Gameplay.setText(kid_label, 'StartKidFriendlyGameBtn');
            if (kid_label.width > 300) kid_label.setScale(300/kid_label.width);

            normalBtn.setInteractive({cursor: 'pointer'});
            normalBtn.once('pointerup', ()=>{
                this.nextScreen();
            });
            normalBtn.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
            });
            kidFriendly.setInteractive({cursor: 'pointer'});
            kidFriendly.once('pointerup', ()=>{
                this.nextScreen();
            });
            kidFriendly.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
            });
        }

        private alreadyChoosen:boolean = false;
        private nextScreen(): void {
            if (this.alreadyChoosen) return;
            this.alreadyChoosen = true;

            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
        }

        public updateScreen(): void {
            super.updateScreen();

            if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                nscs.scene.MainScene.instance.inputController.escPressUsed();
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.InstructionScreen(this.scene));
            }
        }
    }
}